export default {
  label: {
    series: 'Evaluaciones',
  },
};
